<template>
    <div class="el-main-wrapper" style="margin-top: -30px !important">
        <el-row class="el-title-block">
            <h1 class="el-title-with-icon el-title-with-icon--button">
                {{ $t('title.bookings') }}
                <span v-if="selectedContainer"
                    >: {{ selectedContainer.Description }}</span
                >
            </h1>
            <div class="el-title__action-button">
                <v-btn
                    round
                    class="mr-2"
                    color="primary"
                    @click="toggleView"
                    dark
                    >{{ viewText }}
                </v-btn>
                <v-btn
                    round
                    color="primary"
                    id="createBookingBtn"
                    @click.stop="openCreateBookingDialog"
                    dark
                >
                    {{ $t('button.text.createBooking') }}
                </v-btn>
            </div>
        </el-row>

        <!--<button-->
        <!--class="hidden"-->
        <!--id="btnDialog"-->
        <!--@click.stop="createDialog = true"-->
        <!--&gt;</button>-->

        <div>
            <!-- Booking Create Dialog -->
            <div>
                <stc-dialog
                    v-model="createBookingDialog"
                    v-if="permissions.includes('ACTOR_WRITE')"
                    @change="closeCreateBookingDialog"
                >
                    <component
                        v-bind:is="bookingCreateComponent"
                        :isEditable="isCreateDialogEditable"
                        :data="createDialogEditObj"
                        :dateRange="createDialogDateRange"
                        :selectedUnloadingArea="createDialogUnloadingArea"
                    />
                </stc-dialog>
            </div>
            <!--End of Booking Create Dialog-->

            <!-- Material Manager Dialog - BLCNotification List -->
            <div>
                <stc-dialog
                    v-model="materialListDialog"
                    @change="closeMaterialListDialog"
                    v-if="permissions.includes('ACTOR_WRITE')"
                >
                    <component
                        v-bind:is="materialManagerListComponent"
                        :with-permission="false"
                        :dateRange="materialListDateRange"
                    ></component>
                </stc-dialog>
            </div>
            <!--End of Material Manager Dialog - BLCNotification List -->

            <!--Show stc-booking-calendar or stc-booking-list -->
            <component :is="view"></component>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StcDialog from '../../components/Dialog'
import BookingList from '../../components/bookings/BookingList'
import BookingCreate from '../../components/bookings/BookingCreate'
import BookingCalendar from '../../components/bookings/BookingCalendar'
import MaterialManagerList from '../../components/blc/material-manager/MaterialManagerList'

export default {
    name: 'bookings-view',

    data() {
        return {
            createDialog: false,
            materialDialog: false,
            view: 'stc-booking-calendar',
            bookingCreateComponent: '',
            createBookingDialog: false,
            materialManagerListComponent: '',
            materialListDialog: false,
            materialListDateRange: [],
            isCreateDialogEditable: false,
            createDialogEditObj: undefined,
            createDialogDateRange: [],
            createDialogUnloadingArea: undefined,
        }
    },

    components: {
        'stc-dialog': StcDialog,
        'stc-booking-list': BookingList,
        'stc-booking-create': BookingCreate,
        'stc-booking-calendar': BookingCalendar,
        'stc-material-manager-list': MaterialManagerList,
    },

    computed: {
        ...mapGetters(['permissions', 'selectedContainer']),

        viewText() {
            return this.view == 'stc-booking-list'
                ? this.$t('button.text.calendar')
                : this.$t('button.text.list')
        },
    },
    created() {
        Events.$on('booking-create-success', (res) => {
            if (this.createBookingDialog) {
                this.createBookingDialog = false
                this.bookingCreateComponent = ''
                Events.$emit('close-tippy')
                // Note: Calendar will be refresh using the socket event 'refresh-calendar' from backend.
            }
        })
    },
    mounted() {
        Events.$on('actor-creating', () => {
            $('#btnDialog').click()
        })

        Events.$on('actor-editing', () => {
            this.createDialog = true
        })

        Events.$on('actor-updated', () => {
            this.createDialog = false
        })

        Events.$on('actor-created', () => {
            this.createDialog = false

            if (this.selectedContainer.ContainerType === 'CCC') {
                this.$router.push({
                    name: 'blc/material-manager',
                })
            }
        })

        // New Refactoring
        Events.$on('notification-show', (data) => {
            this.materialManagerListComponent = 'stc-material-manager-list'
            this.materialListDateRange = [data.start, data.start]
            this.materialListDialog = true
        })

        Events.$on('calendar-creating', (res) => {
            this.createDialogDateRange = res.dateRange
            this.createDialogUnloadingArea = res.unloadingArea
            this.$nextTick(() => {
                setTimeout(() => {
                    $('#createBookingBtn').click()
                }, 200)
            })
        })

        Events.$on('calendar-editing', (res) => {
            this.createDialogEditObj = res
            if (res.DateFrom) {
                this.createDialogDateRange = [
                    res.DateFrom.toJSDate(),
                    res.DateTo.toJSDate(),
                ]
            }
            this.isCreateDialogEditable = true
            this.$nextTick(() => {
                $('#createBookingBtn').click()
            })
        })
    },
    beforeDestroy() {
        Events.$off('notification-show')
        Events.$off('calendar-creating')
        Events.$off('calendar-editing')
    },
    watch: {
        '$route.query.createBooking': {
            handler(val) {
                if (!val) return

                this.$nextTick(() => {
                    $('#btnDialog').click()
                })
            },
            immediate: true,
        },

        createDialog(newVal) {
            if (newVal === false) {
                Events.$emit('actor-reset')
                Events.$emit('actor-created')
            } else {
                Events.$emit('actor-add-packages')
                Events.$emit('generate-password')
            }
        },
    },

    methods: {
        toggleView() {
            if (this.view === 'stc-booking-calendar') {
                this.view = 'stc-booking-list'
            } else {
                this.view = 'stc-booking-calendar'
            }
        },

        closeDialog() {
            if (this.selectedContainer.ContainerType === 'CCC') {
                this.$router.push({
                    name: 'blc/material-manager',
                })
            }
        },
        openCreateBookingDialog() {
            this.bookingCreateComponent = 'stc-booking-create'
            this.createBookingDialog = true
        },
        closeCreateBookingDialog() {
            this.createBookingDialog = false
            this.bookingCreateComponent = ''
            this.createDialogEditObj = undefined
            this.isCreateDialogEditable = false
            this.createDialogDateRange = []
            this.createDialogUnloadingArea = undefined
            // Events.$emit('close-tippy')
        },
        closeMaterialListDialog() {
            this.materialListDialog = false
            this.materialManagerListComponent = ''
        },
    },
}
</script>
